export default __webpack_public_path__ + "static/media/wallpaper_bg2.c8c04220.jpg";